import { render, staticRenderFns } from "./doctor_animation_help.vue?vue&type=template&id=17a6d674&scoped=true"
var script = {}
import style0 from "./doctor_animation_help.vue?vue&type=style&index=0&id=17a6d674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a6d674",
  null
  
)

export default component.exports